import React, { useEffect, useState } from 'react'
import { Button } from '../../components/Button'
import { X } from 'lucide-react';
import FormField from '../../components/ui/FormField';
import { toast } from 'react-toastify';
import organizationApi from '../../api/organizationApi';
import { useSelector } from 'react-redux';
import { Spinner } from 'reactstrap';
import { indianStatesWithGST } from '../../data/stateData';

const Organization = () => {
    const [isShow, setIsShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingGet, setIsLoadingGet] = useState(false);
    const [errors, setErrors] = useState("");
    const token = useSelector((state) => state.auth.access_token);
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        organizationType: "CA",
        gstNumber: "",
        stateCode: "",
        address: "",
        city: "",
        pincode: "",
        phone: "",
        email: "",
        createdAt: "",
        updatedAt: ""
    });

    useEffect(()=>{
        getData();
    }, []);

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const getData = async () => {
        setIsLoadingGet(true);
        try {
            const response = await organizationApi.getOrginazitionDetailsList( token);

            if (response.success && response.data?.content[0]) {
                console.log("response?.data---->>",response?.data?.content[0]);
                
                setFormData(response?.data?.content[0]);
                setIsLoadingGet(false);
            }
        } catch (error) {
            console.log(error);
            setIsLoadingGet(false);
        }
    };

    const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.organizationType.trim()) newErrors.organizationType = "Organization Type is required";
    if (!formData.gstNumber.trim()) newErrors.gstNumber = "GST Number is required";
    if (!formData.stateCode.trim()) newErrors.stateCode = "State Code is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.pincode.trim()) newErrors.pincode = "Pincode is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            toast.error("Please fill all required fields correctly.");
            return;
        }
        setIsLoading(true);
        try {
            let response;
            if (formData?.id !== "") {
                response = await organizationApi.updateOrginazitionDetails(formData?.id, formData, token);
                toast.success("Organization updated successfully!");
            } else {
                response = await organizationApi.createOrginazitionDetails(formData, token);
                toast.success("Organization created successfully!");
            }

            if (response.success && response.data) {
                setIsShow(false);
                setIsLoading(false);
            }
        } catch (error) {
            // toast.error("Something went wrong");
            setIsLoading(false);
        }
    };


  return (
    <div className="space-y-3">
        {!isShow && 
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-6 py-1">
            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-bold text-gray-900">Organization Details</h1>
                <div className="flex space-x-3">
                    <Button onClick={()=> setIsShow(true)} label="Update" />
                </div>
            </div>
            <div className='border-t-2 mt-2 pt-2'>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
                    <ViewField label="Name" value={formData.name} />
                    <ViewField label="GST Number" value={formData.gstNumber} />
                    <ViewField label="Email" value={formData.email} />
                    <ViewField label="Phone Number" value={formData.phone} />
                    <ViewField label="Organization Type" value={formData.organizationType} />
                    <ViewField label="Address" value={formData.address} />
                    <ViewField
                        label="State"
                        value={
                        indianStatesWithGST.find(s => s.value === formData.stateCode)?.label
                        }
                    />
                    <ViewField label="City" value={formData.city} />
                    <ViewField label="Pincode" value={formData.pincode} />
                </div>
            </div>
        </div>}
        {isShow && 
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-6 py-1">
            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-bold text-gray-900">Organization Details</h1>
                <div className="flex space-x-3">
                    <button onClick={()=> setIsShow(false)} className='text-red-600 p-1 bg-red-50 md:bg-red-100 rounded-md' ><X/></button>
                </div>
            </div>
            <form onSubmit={handleSubmit} className='border-t-2 mt-4 pt-2'>
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-1'>
                    <FormField label="Name" type='text' error={errors.name} required value={formData?.name} onChange={(value) => handleChange('name', value)}/>
                    <FormField label="GST Number" type='gst' error={errors.gstNumber} required value={formData?.gstNumber} onChange={(value) => handleChange('gstNumber', value)}/>
                    <FormField label="Email" type='email' error={errors.email} required value={formData?.email} onChange={(value) => handleChange('email', value)}/>
                    <FormField label="Phone Number" type='number' maxLength={10} error={errors.phone} required value={formData?.phone} onChange={(value) => handleChange('phone', value)}/>
                    <FormField label="Organization Type" error={errors.organizationType} required type='dropdown' options={["CA", "SOFTWARE", "SERVICE", "CONSTRUCTION", "MEDICAL"]} value={formData?.organizationType} onChange={(value) => handleChange('organizationType', value)}/>
                    <FormField label="Address" type='text' error={errors.address} required value={formData?.address} onChange={(value) => handleChange('address', value)}/>
                    <FormField label="State" type='dropdown' error={errors.stateCode} required value={formData?.stateCode} options={indianStatesWithGST} onChange={(value) => handleChange('stateCode', value)}/>
                    <FormField label="City" type='text' error={errors.city} required value={formData?.city} onChange={(value) => handleChange('city', value)}/>
                    <FormField label="Pincode" type='number' maxLength={6} error={errors.pincode} required value={formData?.pincode} onChange={(value) => handleChange('pincode', value)}/>
                </div>
                <div className='flex flex-row items-center justify-end gap-2'>
                    <button
                        type="button"
                        onClick={() => setIsShow(false)} 
                        className="bg-red-50 py-2 px-4 border border-red-300 rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
                    >
                        Cancel
                    </button>
                    {isLoading ? 
                    <Button label={<Spinner size={"sm"}/>}/> :
                    <Button label="Save" type="submit" className="m-2"/>
                    }
                </div>
            </form>
        </div>}
    </div>
  )
}

export default Organization;


const ViewField = ({ label, value }) => (
  <div className="">
    <div className="text-xs text-gray-500 uppercase tracking-wide">
      {label}
    </div>
    <div className="text-sm font-semibold text-gray-800 mt-0 break-words">
      {value || "—"}
    </div>
  </div>
);

